"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDebugEnabled = exports.isProd = exports.getEnv = exports.getNisaubaBaseUrl = exports.getPdfServiceBaseUrl = exports.getMagenumBaseUrl = exports.getS3ImageBaseUrl = exports.getAuGraphApiKey = exports.getAuGraphBaseUrl = exports.getCrudCoreBaseUrl = void 0;
const either_1 = require("./../types/either");
const getCrudCoreBaseUrl = () => {
  const value = process.env.CRUD_CORE_BASE_URL || process.env.REACT_APP_CRUD_CORE_BASE_URL || process.env.GATSBY_CRUD_CORE_BASE_URL;
  if (!value) {
    return (0, either_1.left)(new Error('Please set environment variable (CRUD_CORE_BASE_URL, REACT_APP_CRUD_CORE_BASE_URL, or GATSBY_CRUD_CORE_BASE_URL)'));
  }
  return (0, either_1.right)(value);
};
exports.getCrudCoreBaseUrl = getCrudCoreBaseUrl;
const getAuGraphBaseUrl = () => {
  const value = process.env.AU_GRAPH_BASE_URL || process.env.REACT_APP_AU_GRAPH_BASE_URL || process.env.GATSBY_AU_GRAPH_BASE_URL;
  if (!value) {
    return (0, either_1.left)(new Error('Please set environment variable (AU_GRAPH_BASE_URL, REACT_APP_AU_GRAPH_BASE_URL, or GATSBY_AU_GRAPH_BASE_URL)'));
  }
  return (0, either_1.right)(value);
};
exports.getAuGraphBaseUrl = getAuGraphBaseUrl;
const getAuGraphApiKey = () => {
  const value = process.env.AU_GRAPH_API_KEY || process.env.REACT_APP_AU_GRAPH_API_KEY || process.env.GATSBY_AU_GRAPH_API_KEY;
  if (!value) {
    return (0, either_1.left)(new Error('Please set environment variable (AU_GRAPH_API_KEY, REACT_APP_AU_GRAPH_API_KEY, or GATSBY_AU_GRAPH_API_KEY)'));
  }
  return (0, either_1.right)(value);
};
exports.getAuGraphApiKey = getAuGraphApiKey;
const getS3ImageBaseUrl = () => {
  const value = process.env.S3_IMAGE_BASE_URL || process.env.REACT_APP_S3_IMAGE_BASE_URL || process.env.GATSBY_S3_IMAGE_BASE_URL;
  if (!value) {
    return (0, either_1.left)(new Error('Please set environment variable (S3_IMAGE_BASE_URL, REACT_APP_S3_IMAGE_BASE_URL, or GATSBY_S3_IMAGE_BASE_URL)'));
  }
  return (0, either_1.right)(value);
};
exports.getS3ImageBaseUrl = getS3ImageBaseUrl;
const getMagenumBaseUrl = () => {
  const value = process.env.MAGENUM_API_BASE_URL || process.env.REACT_APP_MAGENUM_BASE_API_URL || process.env.GATSBY_MAGENUM_API_BASE_URL;
  if (!value) {
    return (0, either_1.left)(new Error('Please set environment variable (MAGENUM_API_BASE_URL | REACT_APP_MAGENUM_BASE_API_URL | GATSBY_MAGENUM_API_BASE_URL)'));
  }
  return (0, either_1.right)(value);
};
exports.getMagenumBaseUrl = getMagenumBaseUrl;
const getPdfServiceBaseUrl = () => {
  const value = process.env.PDF_API_BASE_URL || process.env.REACT_APP_PDF_API_BASE_URL || process.env.GATSBY_PDF_API_BASE_URL;
  if (!value) {
    return (0, either_1.left)(new Error('Please set PDF Service Base URL environment variable (PDF_API_BASE_URL | REACT_APP_PDF_API_BASE_URL | GATSBY_PDF_API_BASE_URL)'));
  }
  return (0, either_1.right)(value);
};
exports.getPdfServiceBaseUrl = getPdfServiceBaseUrl;
const getNisaubaBaseUrl = () => {
  const value = process.env.NISAUBA_API_BASE_URL || process.env.REACT_APP_NISAUBA_API_BASE_URL || process.env.GATSBY_NISAUBA_API_BASE_URL;
  if (!value) {
    return (0, either_1.left)(new Error('Please set environment variable (NISAUBA_API_BASE_URL | REACT_APP_NISAUBA_API_BASE_URL | GATSBY_NISAUBA_API_BASE_URL)'));
  }
  return (0, either_1.right)(value);
};
exports.getNisaubaBaseUrl = getNisaubaBaseUrl;
const getEnv = () => process.env.REACT_APP_ENV || process.env.GATSBY_SITE_ENV || '';
exports.getEnv = getEnv;
const isProd = () => ['prod', 'production'].includes((0, exports.getEnv)());
exports.isProd = isProd;
const getDebugEnabled = () => {
  const value = process.env.AU_SDK_DEBUG_ENABLED || process.env.REACT_APP_AU_SDK_DEBUG_ENABLED || process.env.GATSBY_AU_SDK_DEBUG_ENABLED;
  return value === 'true';
};
exports.getDebugEnabled = getDebugEnabled;